module.exports = __webpack_public_path__ + "static/media/24_RamaonaLettkamp_webfinal.a0b757e5.jpg";